export default function CredentialController() {

}